
/**
 * @method 这是路由钩子函数
 * @param { Object } to   到哪里去的路由对象
 * @param { Object } from 从哪里来的路由对象
 */
export default (to, from) => {
  // 有名字就改
  document.title = to.meta.title ? to.meta.title : 'Bloom评委管理系统'
}



// WEBPACK FOOTER //
// ./src/router/route-hook/afterEach.js